const copyTextToClipboard = (content: string) => {
  if (typeof document === 'undefined') return false;

  const textarea = document.createElement('textarea');
  textarea.textContent = content || '';
  // Needs to be `contenteditable` for iOS.
  textarea.contentEditable = 'true';
  // Can't be `readonly` or  `disabled`.
  textarea.readOnly = false;
  textarea.disabled = false;
  // Can't be `display: none` for `select()` to work.
  textarea.setAttribute(
    'style',
    'opacity: 0; position: fixed; top: -1000px; left: -1000px;'
  );
  // Node needs to actually be in the live DOM during copy...
  if (document.body !== null) {
    document.body.appendChild(textarea);
  }
  textarea.select();
  let didCopy = document.execCommand('copy');
  if (!didCopy) {
    // iOS-specific copying
    // Borrowed from http://bit.ly/2Gc3gTp
    const range = document.createRange();
    range.selectNodeContents(textarea);
    const selection = window.getSelection();
    selection!.removeAllRanges();
    selection!.addRange(range);
    textarea.setSelectionRange(0, 999999);
    didCopy = document.execCommand('copy');
  }
  // ...and then we can trash it.
  if (document.body !== null) {
    document.body.removeChild(textarea);
  }
  return didCopy;
};

export default copyTextToClipboard;
